import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { useOnboardingStatus } from '../../hooks/api/use-onboarding.js';
import { useOrganization } from '../../lib/auth-provider.js';
import { pendingMandatorySteps } from '../../onboarding/mandatory.js';
import { claimWizardRedirect } from '../../onboarding/session-memory.js';
import { useOnboardingScope } from '../../onboarding/use-onboarding-scope.js';

export const WELCOME_PATH = '/bienvenue';

/**
 * Premier passage : un membre dont l'assistant n'a été ni terminé ni passé y est conduit, une fois
 * par session et par cabinet. Seulement depuis le tableau de bord, là où mène la connexion : un
 * lien ouvert depuis un courriel ou la console de plateforme arrive où il visait. L'assistant
 * étant toujours passable, il n'y a pas de boucle possible.
 *
 * Il attend que les étapes obligatoires soient faites : tant qu'elles ne le sont pas, c'est la
 * page de mise en route qui conduit, pas cet assistant.
 */
export function OnboardingRedirect() {
  const [location, navigate] = useLocation();
  const { organization } = useOrganization();
  const inScope = useOnboardingScope();
  const onDashboard = location === '/dashboard';
  const status = useOnboardingStatus(inScope && onDashboard);
  const pending = status.data?.wizard === 'pending';
  const mandatoryOpen =
    status.data?.steps !== undefined && pendingMandatorySteps(status.data.steps).length > 0;
  const organizationId = organization?.id ?? null;

  useEffect(() => {
    if (!pending || !onDashboard || !inScope || organizationId === null || mandatoryOpen) return;
    if (claimWizardRedirect(organizationId)) navigate(WELCOME_PATH);
  }, [pending, onDashboard, inScope, organizationId, mandatoryOpen, navigate]);

  return null;
}
